import { createContext, ReactElement, useContext } from 'react';

import { ISpaceSelectProps } from './types';

export type ISpaceSelectContext = { renderSpaceSelect: (props: ISpaceSelectProps) => ReactElement };

export const SpaceSelectContext = createContext<ISpaceSelectContext>({ renderSpaceSelect: () => <>{null}</> });

export const useSpaceSelectContext = () => useContext(SpaceSelectContext);
